/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface MonthPlanRemoveVariableCostFromMarginRequestDto
 */
export interface MonthPlanRemoveVariableCostFromMarginRequestDto {
  /**
   *
   * @type {string}
   * @memberof MonthPlanRemoveVariableCostFromMarginRequestDto
   */
  fundId: string;
}

export function MonthPlanRemoveVariableCostFromMarginRequestDtoFromJSON(
  json: any
): MonthPlanRemoveVariableCostFromMarginRequestDto {
  return MonthPlanRemoveVariableCostFromMarginRequestDtoFromJSONTyped(json, false);
}

export function MonthPlanRemoveVariableCostFromMarginRequestDtoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): MonthPlanRemoveVariableCostFromMarginRequestDto {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    fundId: json["fundId"],
  };
}

export function MonthPlanRemoveVariableCostFromMarginRequestDtoToJSON(
  value?: MonthPlanRemoveVariableCostFromMarginRequestDto | null
): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    fundId: value.fundId,
  };
}
